<template>
	<div class="msg">
		<div class="ask">立即咨询服务</div>
		<input type="text" name="name" v-model="name" placeholder="姓名" class="ipt"/>
		<input type="text" name="phone" v-model="phone" placeholder="手机号" class="ipt"/>
		<input type="text" name="conpany" v-model="conpany" placeholder="公司名称(选填)" class="ipt"/>
		<div @click="submit" class="msgBtn">
			提交
		</div>
		<div class="callMe">联系我们请拨打热线：159 8989 7729</div>
		<el-button :plain="true" @click="open2"></el-button>
	</div>
	
</template>

<script>
import request from '../utils/request.js'
export default {
	name:"msgFoot",
	data(){
		return{
			name:'',
			phone:'',
			conpany:''
		}
	},
	methods:{
		open2() {
			this.$message({
			    message: '提交成功，稍后我们将会有客服人员联系您，请保持电话畅通',
			    type: 'success'
			});
		 },
		async submit () {
			if(!this.name || !this.phone){
				this.$message({
				    message: '请输入姓名和手机号',
				    type: 'info'
				});
				return
			}
			if (!/^1[3456789]\d{9}$/.test(this.phone)) {
				this.$message({
					message: '请填写正确的手机号',
					type: 'info'
				});
			    return;
			}
			var params = {};
			params.name = this.name;
			params.mobile = this.phone;
			params.comp = this.conpany;
			console.log('xxx', params);
			const res = await request({
				method:'POST', 
				url:'/soft/consult/save', 
				data: params
			})
			if(res.code!=0) return
			this.open2()
		}
		
	}
}
</script>

<style>
	@media screen and (min-width: 1200px){
		.msgBtn{
			display: block;
			width: 400px;
			line-height: 50px;
			text-align: center;
			height: 50px;
			color: #fff;
			background-color: #ff6a00;
			margin: 32px auto 0;
		}
		.ipt{
			display: block;
			box-sizing: border-box;
			width: 400px;
			line-height: 50px;
			height: 50px;
			background: #fff;
			border: 1px solid #dedede;
			border-radius: 2px;
			padding: 0 24px;
			margin: 0 auto 24px;
		}
		.ask{
			font-size: 25px;
			color: #323232;
			text-align: center;
			line-height: 25px;
			
			margin-bottom: 40px;
		}
		.msg{
			background-image: url('../assets/images/def/form-bg.jpg');
			width: 100%;
			background-repeat: no-repeat;
			background-size: 100%;
			height: 429px;
			padding-top: 56px;;
		}
	}
	@media screen and (min-width: 600px) and (max-width: 1200px){
		.msgBtn{
			display: block;
			width: 80%;
			line-height: 6vw;
			text-align: center;
			height: 6vw;
			color: #fff;
			font-size: 2.4vw;
			background-color: #ff6a00;
			margin: 6.4vw auto 0;
		}
		.ipt{
			display: block;
			box-sizing: border-box;
			width: 80%;
			line-height: 8vw;
			height: 8vw;
			background: #fff;
			border: 1px solid #dedede;
			border-radius: 2px;
			padding: 0 6.8vw;
			margin: 0 auto 6.8vw;
		}
		.ask{
			font-size: 4vw;
			color: #323232;
			text-align: center;
			line-height: 6vw;
			margin-bottom: 6vw;
		}
		.msg{
			background-image: url('../assets/images/def/form-bg.jpg');
			width: 100%;
			background-repeat: no-repeat;
			background-size: 100%;
			padding-top: 5.2vw;
		}
	}
	@media screen and (max-width: 600px){
		.msgBtn{
			display: block;
			width: 80%;
			line-height: 6vw;
			text-align: center;
			font-size: 2.4vw;
			height: 6vw;
			color: #fff;
			background-color: #ff6a00;
			margin: 6.4vw auto 0;
		}
		.ipt{
			display: block;
			box-sizing: border-box;
			width: 80%;
			line-height: 6vw;
			height: 6vw;
			background: #fff;
			border: 1px solid #dedede;
			border-radius: 2px;
			padding: 0 4.8vw;
			margin: 0 auto 4.8vw;
		}
		.ask{
			font-size: 3vw;
			color: #323232;
			text-align: center;
			line-height: 6vw;
			margin-bottom: 4vw;
		}
		.msg{
			background-image: url('../assets/images/def/form-bg.jpg');
			width: 100%;
			background-repeat: no-repeat;
			background-size: 100%;
			padding-top: 5.2vw;
		}
	}
</style>
